import { useEffect } from 'react';
import styles from './ToastNotification.module.css';

export default function ToastNotification({ message, type = 'success', onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 3000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div className={`${styles.toast} ${styles[type]}`}>
      <span className={styles.icon}>{type === 'success' ? '✓' : '!'}</span>
      <span className={styles.message}>{message}</span>
    </div>
  );
}
